module.exports = __webpack_public_path__ + "img/user_lz_lx.0232e031.png";